import React from "react";
import { Link, useLocation } from "react-router-dom";

const tabs = [
  { to: "/behavior", label: "Overview" },
  { to: "/behavior/pages", label: "Pages" },
  { to: "/behavior/sessions", label: "Sessions" },
  { to: "/behavior/exit-intent", label: "Exit Intent" },
  { to: "/behavior/triggers", label: "Triggers" },
];

export default function BehaviorNav() {
  const location = useLocation();
  return (
    <div className="flex gap-1 bg-dark-300 border border-dark-50 rounded-lg p-1">
      {tabs.map((tab) => (
        <Link
          key={tab.to}
          to={tab.to}
          className={`px-3 py-1.5 text-xs rounded-md transition-colors ${
            location.pathname === tab.to
              ? "bg-copper/20 text-copper"
              : "text-gray-400 hover:text-white"
          }`}
        >
          {tab.label}
        </Link>
      ))}
    </div>
  );
}
